<!-- AddPathButton.svelte -->
<script>
	import { pathID } from './AppState.js';
import { tick } from 'svelte';

	// two-way-bindable prop 🔄
	let { 
		pathNames = $bindable({}), 
		buttonText = "Add Path",
		itemIcon = "./Icons/Path icon rectangular v2.svg",
		itemPlaceholder = "Path"
	} = $props();

	async function addInput(event) {
		event.preventDefault();          // keep the form on the page
		const key = `Path ${$pathID++}`; // increment the store
		pathNames = { ...pathNames, [key]: '' };
		// Ensure DOM is updated before scrolling
		await tick();
		const anchor = document.querySelector('.AddPathButton-scrolling-anchor');
		if (anchor) {
			const { bottom } = anchor.getBoundingClientRect();
			if (bottom > window.innerHeight) {				// solo hace scroll hacia abajo si el botón queda fuera, nunca hacia arriba
				anchor.scrollIntoView({ behavior: 'smooth', block: 'end' });
			}
		}
		// Focus the newly created input
		const textInputs = document.querySelectorAll('.AddPath input[type="text"]');
		textInputs[textInputs.length - 1]?.focus();
	}

	function handleInput(key, event) {
		pathNames = { ...pathNames, [key]: event.target.value };
	}

	function deleteInput(key) {
		const { [key]: _, ...rest } = pathNames;
		pathNames = rest;
	}
</script>

<div class="AddPath">
	<form onsubmit={addInput}>
		{#each Object.keys(pathNames) as key}
			<div>
				{#if itemIcon.startsWith('./') || itemIcon.startsWith('/') || itemIcon.includes('.')}
					<!-- SVG/Image icon -->
					<img src={itemIcon} alt="Item Icon"
						 style="height:1.2em;margin-left:-1.5em;margin-right:1.5em;" />
				{:else}
					<!-- Emoji icon -->
					<span class="emoji-icon" style="font-size:1.2em;margin-left:-1.5em;margin-right:1.5em;">
						{itemIcon}
					</span>
				{/if}

				<input
					type="text"
					placeholder={itemPlaceholder}
					value={pathNames[key]}
					oninput={(event) => handleInput(key, event)}
				/>

				<button type="button" class="delete is-large" aria-label="Delete {itemPlaceholder.toLowerCase()} ${key}"
						onclick={() => deleteInput(key)}>
				</button>
			</div>
		{/each}

		<button class="AddPath-button" type="submit">
			{buttonText}
		</button>
	</form>
</div>

<style>
	.AddPath form {
		display: flex;
		flex-direction: column;
		align-items: center; /* Centering the child elements */
	}

	.AddPath div {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		width: 80vw;
		max-width: 600px;
	}

	.AddPath-button {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 20px; /* More padding for easier tapping */
		margin: 0em 0em; /* More spacing */
	}

	button.delete {
		margin: 1em;
		padding: 0.7em 1.3em;
		border-radius: 7px;
	}

	input[type="text"] {
		width: 90%; /* Adapt width to mobile */
		max-width: 600px; /* Set a maximum width for larger screens */
		padding: 10px;
	}

	.emoji-icon {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		user-select: none;
	}
</style>
